import { render } from "./ExportButton.vue?vue&type=template&id=5cdd8d65&scoped=true"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"

import "./ExportButton.vue?vue&type=style&index=0&id=5cdd8d65&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdd8d65"]])

export default __exports__